import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";

const NetActivity = () => {
  const [userData, setUserData] = useState<any>(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("NetActivity", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setUserData(response);
      });
  }, []);
  
  // useEffect(() => {
  //   axios
  //     .post(`http://192.169.179.33/PMSWEBAPI/api/dashboards`, NetActivity, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((res) => setUserData(res.data))
  //     .catch((err) => console.log(err));
  // }, [token]);
  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  return (
    <div className="w-100 netActivity">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body">
            <h1 className="display-6 mb-0 mt-4 activityValue">
              {userData && (
                <div>{"$" + currencyFormat(userData[0].accountBalance)}</div>
              )}
            </h1>
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title">Account Balance</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body">
            <h1 className="display-6 mb-0 mt-4 activityValue">
              {userData && (
                <div>{"$" + currencyFormat(userData[0].contributions)}</div>
              )}
            </h1>
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title">Net Activity</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-12 d-none">
        <div className="card">
          <div className="card-body">
            <h1 className="display-6 mt-1 mb-0 activityValue">
              {userData && (
                <div>
                  <div className="mb-2 mt-1">
                    {"$" + currencyFormat(userData[0].contributions)}{" "}
                  </div>
                  <div className="">
                    {userData[0].redemptions >= 0 ? (
                      "$" + currencyFormat(userData[0].redemptions)
                    ) : (
                      <span className="text-danger sellValue">
                        {"(" +
                          "$" +
                          currencyFormat(userData[0].redemptions).slice(1) +
                          ")"}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </h1>
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title">Cap Stock Activity</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body">
            <h1 className="display-6 mt-1 mb-1 activityValue">
              {userData && (
                <div>{"$" + currencyFormat(userData[0].gainOrLoss)}</div>
              )}
            </h1>
            <div className="mb-0">
            {
                  userData && userData.map((e:any) =>{
                      return  e.netPerf >= 0 ? 
                      <span className="text-success sellValue"> {currencyFormat(e.netPerf)}%</span> 
                      : <span className="text-danger sellValue">-{currencyFormat(e.netPerf)}% </span>
                  })
                }
              
               
              
            </div>
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title">Gain/Loss</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { NetActivity };
